var $68ce88a369285902$exports = {};
$68ce88a369285902$exports = {
  "backButton": args => "G\xE5 tilbake til ".concat(args.prevMenuButton),
  "moreActions": "Flere handlinger",
  "unavailable": "Utilgjengelig, utvid for detaljer"
};
export { $68ce88a369285902$exports as default };